import { DatasetChartProps } from 'components/dashboard/charts/interfaces';

export const defaultLoadConf = {
    lead: 0,
    lag: 6,
    leadUnit: 'HOURS',
    lagUnit: 'HOURS',
    alignUnit: 'MINUTES',
};

export const defaultDatasetLineChartConfig: DatasetChartProps = {
    height: 400,
    showDateSelection: true,
    hideRefresh: false,
    loadConf: defaultLoadConf,
    updateFrequency: 5,
    datasets: [],
    toggleTracesGrouping: true,
    timeAxisStepSeconds: 0
};